import { render, staticRenderFns } from "./GraphManagement.vue?vue&type=template&id=bb5a8e64&scoped=true"
import script from "./GraphManagement.vue?vue&type=script&lang=js"
export * from "./GraphManagement.vue?vue&type=script&lang=js"
import style0 from "./GraphManagement.vue?vue&type=style&index=0&id=bb5a8e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5a8e64",
  null
  
)

export default component.exports